import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './dropdown-menu.module.js';
import { Divider } from '../../divider/divider.js';
var DropdownMenuSeparator = /*#__PURE__*/forwardRef(function (_, forwardedRef) {
  return jsx(Divider, {
    ref: forwardedRef,
    className: styles.dropdownMenuItemSeparator
  });
});
DropdownMenuSeparator.displayName = 'DropdownMenuSeparator';
export { DropdownMenuSeparator };